import { Id } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { RetryQuery } from 'shared/queries/utils'
import { convertCompanyPreferences } from './shared/convert'
import keys from './shared/keys'
import * as Response from './shared/response'
import { CompanyPreferencesData } from './shared/types'

export function useCompanyPreferences(companyId?: Id, retryQuery?: RetryQuery) {
  const { server } = useServer()
  return useQuery<CompanyPreferencesData>({
    queryKey: keys.all,
    queryFn: fetchCompanyPreferences,
    enabled: !!companyId,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
    retry: retryQuery ?? false,
  })

  async function fetchCompanyPreferences() {
    if (!companyId) {
      throw new Error('Company id invalid')
    }
    try {
      const response = await server.get<Response.Company>(
        `/v2/companies/${companyId}/preferences`
      )
      return convertCompanyPreferences(response)
    } catch (err: any) {
      throw err
    }
  }
}
